import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import reportWebVitals from './reportWebVitals';
import {Route, Routes, BrowserRouter} from 'react-router-dom';
import App from './app';
import Login from './login';
import Insurer from './insurer-login'
import Register from './register';
import {CookiesProvider} from 'react-cookie';



function Router(){
  return(
    <React.StrictMode>
    <CookiesProvider>
      <BrowserRouter>
        <Routes>
        <Route exact path="/" element = {<App />}/>
          <Route exact path="/login" element = {<Login />}/>
          <Route exact path="/register" element = {<Register />}/>
          <Route exact path="/insurer" element = {<Insurer />}/>
        </Routes> 
      </BrowserRouter>
      </CookiesProvider>
    </React.StrictMode>

  );
}

ReactDOM.render(<Router/>, document.getElementById("root"))
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
 